// This file is auto-generated. Edit data.json to change it.
import { DataProvider } from 'Simple/Data'
import useDataTransform from './useDataTransform'
import useDataOnSubmit from './useDataOnSubmit'
import rdata from './data.json'
import React from 'react'
import View from './view'

/** @type {import('Simple/types.js').Data} */
export default function ContentData(props) {
  let data = useDataTransform(props, rdata.value)
  let onSubmit = useDataOnSubmit(props, data)

  return (
    <DataProvider
      context="seat"
      value={data}
      viewPath={props.viewPath}
      onSubmit={onSubmit}
    >
      <View {...props} />
    </DataProvider>
  )
}